<template>
  <component
    style=''
    :is="baseComponent"
    :to="link.path ? link.path : '/'"
    :class="{ active: isActive }"
    tag="li"
  >
    <a
      v-if="isMenu"
      href="#"
      class="nav-link sidebar-menu-item"
      :aria-expanded="!collapsed"
      data-toggle="collapse"
      @click.prevent="collapseMenu"
    >
      <img
        v-if="link.img && link.slug === 'unidades'"
        src="../../../public/img/units-icon.png"
        class="mdi md-icon md-icon-font md-theme-default"
        style="float: left; margin-right: 15px; display: inline;"
      />
      <img
        v-else-if="link.img && link.slug === 'configuracoes'"
        src="../../../public/img/settings-icon.png"
        class="mdi md-icon md-icon-font md-theme-default"
        style="float: left; margin-right: 15px; display: inline;"
      />
      <VpnKey
        v-else-if="link.img && link.slug === 'gestao'"
        class="mdi md-icon md-icon-font md-theme-default"
        style="float: left; margin-top: 5px; margin-right: 15px; display: inline;"
      />
      <template v-if="!link.img">
        <span
          class="mdi md-icon md-icon-font md-theme-default"
          style="float: left; margin-right: 15px;"
          :class="'mdi-' + link.icon"
        ></span>
      </template>
      <p>
        {{ link.name }}
        <b class="caret"></b>
      </p>
    </a>

    <collapse-transition>
      <div v-if="$slots.default || this.isMenu" v-show="!collapsed">
        <ul class="nav">
          <slot></slot>
        </ul>
      </div>
    </collapse-transition>

    <slot
      name="title"
      v-if="children.length === 0 && !$slots.default && link.path"
    >
      <component
        :to="link.path"
        @click.native="linkClick"
        :is="elementType(link, false)"
        :class="{ active: link.active}"
        class="nav-link"
        :target="link.target"
        :href="link.path"
      >
        <template v-if="addLink || isIma || isIpmc || isSesam">
          <span class="sidebar-mini">
            <v-icon
              v-if='link.path === "/lista-assistentes"'
            >mdi-robot</v-icon>
            <v-icon
              v-else-if='link.path === "/visao-geral"'
            >mdi-monitor-dashboard</v-icon>
            <v-icon v-else-if='link.path === "/eficiencia"'
            >mdi-finance</v-icon>
            <v-icon v-else-if='link.path === "/curadoria"'
            >mdi-grid-large</v-icon>
            <v-icon v-else-if='link.path === "/mensagens-nao-entendidas"'
            >mdi-message-bulleted-off</v-icon>
            <v-icon v-else-if='link.path === "/templates"'
            >mdi-message-reply</v-icon>
            <v-icon v-else-if='link.path === "/campanhas"'
            >mdi-bullhorn</v-icon>
            <v-icon v-else-if='link.path === "/edicao-simplificada"'
            >mdi-playlist-edit</v-icon>
            <v-icon class="material-icons-outlined" v-else-if='link.path === "/contatos-ativos"'
              style='color: #ffff !important;'
            >contact_page</v-icon>
            <SpaceDashboard
              v-else-if='link.path === "/campanha-desempenho-geral"'
              class="mdi md-icon md-icon-font md-theme-default"
              :class="{'sidebar-icon-ima': isIma || isIpmc || isSesam}"
              style="float: left; margin-right: 15px;"
            />
            <TeamsIcon
              v-else-if='link.path === "/consulta-usuario-teams"'
              class="mdi md-icon md-icon-font md-theme-default"
              style="float: left; margin-right: 15px;"
            />
            <TableChartView
              v-else-if='link.path === "/lista-campanhas"'
              class="mdi md-icon md-icon-font md-theme-default"
              style="float: left; margin-right: 15px;"
              :class="{'sidebar-icon-ima': isIma || isIpmc || isSesam}"
            />
            <ManageAccount
              v-else-if='link.path === "/configuracoes-usuario-perfil"'
              class="mdi md-icon md-icon-font md-theme-default"
              style="float: left; margin-right: 15px;"
            />
            <ListAll
              v-else-if='link.path === "/configuracoes-funcionalidades"'
              class="mdi md-icon md-icon-font md-theme-default"
              style="float: left; margin-right: 15px;"
            />
            <AccountCircle
              v-else-if='link.path === "/users"'
              class="mdi md-icon md-icon-font md-theme-default"
              style="float: left; margin-right: 15px;"
            />
            <template v-else>{{ linkPrefix }}</template>
          </span>
          <span
          class="sidebar-normal"
          >{{ link.name }}</span>
        </template>
        <template v-else>
          <span
            class="mdi md-icon md-icon-font md-theme-default"
            style="float: left; margin-right: 15px;"
            :class="'mdi-' + link.icon"
          ></span>
          <p>{{ link.name }}</p>
        </template>
      </component>
    </slot>
  </component>
</template>
<script>
import ListAll from '@/assets/img/list_alt.svg'
import AccountCircle from '@/assets/img/account_circle.svg'
import VpnKey from '@/assets/img/vpn_key.svg'
import ManageAccount from '@/assets/img/manage_accounts.svg'
import SpaceDashboard from '@/assets/img/space_dashboard.svg'
import TeamsIcon from '@/assets/img/teams.svg'
import TableChartView from '@/assets/img/table_chart_view.svg'
import isTenantMixin from '../mixins/isTenantMixin'
export default {
  name: 'sidebar-item',
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: () => {
        return {
          customIcon: false,
          name: '',
          path: '',
          children: []
        }
      }
    }
  },
  components: {
    ListAll,
    AccountCircle,
    VpnKey,
    ManageAccount,
    SpaceDashboard,
    TableChartView,
    TeamsIcon
  },
  provide () {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    }
  },
  inject: {
    addLink: { default: null },
    removeLink: { default: null },
    autoClose: {
      default: true
    }
  },
  data () {
    return {
      children: [],
      collapsed: true
    }
  },
  mixins: [isTenantMixin],
  computed: {
    baseComponent () {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link'
    },
    linkPrefix () {
      if (this.link.name) {
        let words = this.link.name.split(' ')
        return words.map(word => word.substring(0, 1)).join('')
      }
      return false
    },
    isMenu () {
      return this.children.length > 0 || this.menu === true
    },
    isActive () {
      if (this.$route && this.$route.path) {
        let matchingRoute = this.children.find(c =>
          this.$route.path.startsWith(c.link.path)
        )
        if (matchingRoute !== undefined) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    addChild (item) {
      const index = this.$slots.default.indexOf(item.$vnode)
      this.children.splice(index, 0, item)
    },
    removeChild (item) {
      const tabs = this.children
      const index = tabs.indexOf(item)
      tabs.splice(index, 1)
    },
    elementType (link, isParent = true) {
      if (link.isRoute === false) {
        return isParent ? 'li' : 'a'
      } else {
        return 'router-link'
      }
    },
    linkAbbreviation (name) {
      const matches = name.match(/\b(\w)/g)
      return matches.join('')
    },
    linkClick () {
      if (!this.addLink) {
        this.$sidebar.collapseAllMenus()
      }

      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false)
      }
    },
    collapseMenu () {
      if (this.collapsed) {
        this.$sidebar.addSidebarLink(this)
        this.$sidebar.collapseAllMenus()
      }

      this.collapsed = !this.collapsed
    },
    collapseSubMenu (link) {
      link.collapsed = !link.collapsed
    }
  },
  mounted () {
    if (this.addLink) {
      this.addLink(this)
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false
    }
  },
  destroyed () {
    this.$sidebar.removeSidebarLink(this)
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
    if (this.removeLink) {
      this.removeLink(this)
    }
  }
}
</script>
<style scoped lang="scss">
.sidebar-menu-item {
  cursor: pointer;
}

.sidebar-mini {
  ::v-deep .v-icon {
    transform: translate(-10%, -20%) !important;
  }
}

.sidebar-icon-ima {
  width: 30px !important;
}

a {
  position: relative;
}
a > span, img {
  left: 0%;
  top: 0%;
  transform: translate(12%, 12%);
}
a > img {
  left: 0%;
  top: 0%;
  transform: translate(12%, 12%);
}
</style>
